import { useEffect } from "react";
import { useLocation } from "react-router-dom";
export function usePageMotion() {
  const { pathname } = useLocation();
  useEffect(() => {
    const preference = window.matchMedia("(prefers-reduced-motion: reduce)");
    let observer: IntersectionObserver | undefined;
    let mutation: MutationObserver | undefined;
    function setup() {
      observer?.disconnect();
      mutation?.disconnect();
      document.documentElement.classList.remove("motion-ready");
      if (preference.matches || !("IntersectionObserver" in window)) return;
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.target.classList.toggle("is-visible", entry.isIntersecting);
          });
        },
        { threshold: 0.08, rootMargin: "0px 0px -24px 0px" },
      );
      function observe() {
        document
          .querySelectorAll("[data-reveal]:not([data-observed])")
          .forEach((el) => {
            el.setAttribute("data-observed", "");
            observer?.observe(el);
          });
      }
      document
        .querySelectorAll("[data-observed]")
        .forEach((el) => el.removeAttribute("data-observed"));
      observe();
      document.documentElement.classList.add("motion-ready");
      mutation = new MutationObserver(observe);
      mutation.observe(document.getElementById("root")!, {
        childList: true,
        subtree: true,
      });
    }
    setup();
    preference.addEventListener("change", setup);
    return () => {
      observer?.disconnect();
      mutation?.disconnect();
      document.documentElement.classList.remove("motion-ready");
      preference.removeEventListener("change", setup);
    };
  }, [pathname]);
}
